import React, { useState } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { AppContent, AppHeader } from '../components/index'
import { GetUserName } from '../services/AuthUser'
import { SeverityLevel } from '@microsoft/applicationinsights-web'
import { getAppInsights } from '../services/TelemetryService'
import { fnBrowserDetect } from '../utils/utils'
import { useLocation } from 'react-router-dom'
const DefaultLayout = () => {
  const [isDarkTheme, setIsDarkTheme] = useState()
  const toggleTheme = (data) => {
    setIsDarkTheme(data)
  }
  const location = useLocation()
  let appInsights = getAppInsights()
  let userDetails = GetUserName()
  function trackException(e) {
    e &&
      appInsights.trackException({
        error:
          'User Name: ' +
          userDetails?.[0]?.userName +
          ' User Email: ' +
          userDetails?.[0]?.userEmail +
          ' Browser: ' +
          fnBrowserDetect() +
          ' Unhandled error occured: ' +
          new Error(e),
        severityLevel: SeverityLevel.Error,
      })
  }

  return (
    <>
      <div
        className={`d-flex flex-column ${location.pathname === '/' ? ' wrapper-img' : 'p-0'}  ${
          !isDarkTheme ? 'dark' : 'light'
        } min-vh-100`}
      >
        <AppHeader
          userDetails={GetUserName()}
          toggleClick={toggleTheme}
          showBamHeader={location.pathname === '/' ? false : true}
        />
        {/* <div
          className={` ${location.pathname === '/' ? ' wrapper-img' : 'p-0'}  ${
            !isDarkTheme ? 'dark' : 'light'
          }`}
        > */}
        <ErrorBoundary
          fallbackRender={({ error }) => (
            <>
              {error && trackException(error)}
              <div role="alert" className="text-white text-center" data-testid="errorFallback">
                <div>Something went wrong</div>
                <pre>Please be patient and refresh the application</pre>
                <button
                  className="px-3 py-1 rounded-pill"
                  onClick={() => {
                    document.location.href = '/'
                  }}
                >
                  Go To Homepage
                </button>
              </div>
            </>
          )}
        >
          <AppContent />
        </ErrorBoundary>
      </div>
      {/* </div> */}
    </>
  )
}

export default DefaultLayout
